export default __webpack_public_path__ + "static/media/element_59.ea639c67.avif";